<template>
  <div>
    <div class="flex text-14 m-b-10">
      <div class="text-red m-r-5">＊</div>
      因圖資系統計算有機會產生偏差，故系統將自動保留 100 公尺的誤差值。<br>
      例如：若您的門檻設定為 1000 公尺，客人的距離為 1050 公尺，系統將視為符合門檻。
    </div>
    滿
    <input
      class="form-control w-90 inline-block"
      placeholder=""
      type="text"
      v-model.number="deliveryWays.price"
    />
    <span class="nd-tooltip">
      <ion-icon name="help-circle"></ion-icon>
      <span class="nd-tooltip-text">
        外送訂單可下單的最低金額門檻。若需設定訂單金額與對應的外送距離，可按「綠色+」按鈕設定。
      </span>
    </span>
    元即可外送
    <button
      class="btn btn-success"
      @click="addOtherDelivery()"
    >
      <i
        class="fa fa-plus-circle"
        aria-hidden="true"
      />
    </button>
    <span
      v-for="(delivery, index) in deliveryOtherKM"
      :key="index"
    >
      <br>
      <hr>
      滿
      <!-- 不希望第{0}的值被更改，因為要連動於上方「外送」的deliveryWays.price -->
      <input
        class="form-control w-90 inline-block"
        placeholder=""
        type="text"
        :disabled="index === 0"
        v-model.number="delivery.price"
        @change="changeOtherDelivery()"
      />
      元可外送
      <input
        class="form-control w-90 inline-block"
        placeholder=""
        type="text"
        v-model.number="delivery.distance_km"
        @change="changeOtherDelivery()"
      />
      公里以內 <span v-if="!maxDeliveryDistanceKM && index === deliveryOtherKM.length - 1">(以上)</span>
      <button
        class="btn btn-default"
        @click="removeOtherDelivery(index)"
      ><i
          class="fa fa-minus-circle"
          aria-hidden="true"
        ></i></button>
    </span>
    
    <hr>
    最遠可送
    <input
      maxlength="6"
      class="form-control w-90 inline-block"
      placeholder=""
      type="text"
      v-model.number="maxDeliveryDistanceKM"
      @change="changeOtherDelivery()"
    />
    公里
  </div>
</template>

<script>
import numeral from 'numeral'

export default {
  props: {
    'storeInfo': {
      type: Object
    },
    'deliveryWays': {
      type: Object
    },
    'deliveryOther': {
      type: Array
    },
    'deliveryWaysInfo': {
      type: Array
    }
  },
  data () {
    return {
      numeral
    }
  },
  computed: {
    maxDeliveryDistanceKM: {
      get () {
        return this.storeInfo.max_delivery_distance_m ? numeral(this.storeInfo.max_delivery_distance_m).divide(1000).value() : null
      },
      set (val) {
        let info = JSON.parse(JSON.stringify(this.storeInfo))
        info.max_delivery_distance_m = val ? numeral(val).multiply(1000).value() : null
        this.$emit('update:storeInfo', info)
      }
    },
    deliveryOtherKM: {
      get () {
        let deliveryOther = JSON.parse(JSON.stringify(this.deliveryOther))
        return deliveryOther.map(item => {
          return {
            ...item,
            distance_km: item.distance_m ? numeral(item.distance_m || 0).divide(1000).value() : null
          }
        })
      },
      set (val) {
        let deliveryOtherKM = JSON.parse(JSON.stringify(val))
        let deliveryOther = deliveryOtherKM.map(item => {
          item.distance_m = item.distance_km ? numeral(item.distance_km || 0).multiply(1000).value() : ''
          return item
        })
        this.$emit('update:deliveryOther', deliveryOther)
      }
    }
  },
  methods: {
    addOtherDelivery () {
      const isSupport = this.deliveryWaysInfo.find(function (elm) { return elm.take_type === 3 }).is_support
      const isEnable = this.deliveryWaysInfo.find(function (elm) { return elm.take_type === 3 }).is_enable
      var option = { take_type: 3, distance_m: 0, distance_km: 0, price: 0, is_support: isSupport, is_enable: isEnable, is_default: 0 }
      if (!this.deliveryOtherKM.length) option.price = this.deliveryWaysInfo[2].price
      this.deliveryOtherKM.push(option)
      this.changeOtherDelivery()
    },
    removeOtherDelivery (index) {
      this.deliveryOtherKM.splice(index, 1)
      this.changeOtherDelivery()
    },
    changeOtherDelivery () {
      this.deliveryOtherKM.forEach((item, index) => {
        if (!item.price) item.price = 0
        if (!item.distance_km) item.distance_km = 0

        // 判斷是否大於最遠可送
        if (this.maxDeliveryDistanceKM && item.distance_km > this.maxDeliveryDistanceKM) {
          item.distance_km = 0
        }
      })

      if (this.deliveryWays.price && this.deliveryOtherKM[0]) {
        this.deliveryOtherKM[0].price = this.deliveryWays.price
      }

      this.deliveryOtherKM = JSON.parse(JSON.stringify(this.deliveryOtherKM))
    }
  }
}
</script>



// WEBPACK FOOTER //
// DeliveryLimit.vue?0f51607c